var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500977,
    y: 0.500977,
    width: 30.998,
    height: 30.998,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500977,
    y: 0.500977,
    width: 30.998,
    height: 30.998,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 16C23.9995 18.1216 23.1567 20.1563 21.6565 21.6565C20.1563 23.1567 18.1216 23.9995 16 23.9995C13.8784 23.9995 11.8437 23.1567 10.3435 21.6565C8.84329 20.1563 8.00049 18.1216 8.00049 16C8.00049 13.8784 8.84329 11.8437 10.3435 10.3435C11.8437 8.84329 13.8784 8.00049 16 8.00049C18.1216 8.00049 20.1563 8.84329 21.6565 10.3435C23.1567 11.8437 23.9995 13.8784 23.9995 16ZM16.287 13.9061C15.509 14.2301 13.9531 14.9001 11.6213 15.916C11.2433 16.066 11.0443 16.214 11.0263 16.358C10.9963 16.601 11.3013 16.6969 11.7163 16.8279L11.8912 16.8829C12.2992 17.0159 12.8492 17.1709 13.1342 17.1769C13.3942 17.1829 13.6831 17.0769 14.0021 16.8569C16.181 15.386 17.3059 14.6431 17.3759 14.6271C17.4259 14.6151 17.4959 14.6011 17.5419 14.6431C17.5889 14.6841 17.5839 14.7631 17.5789 14.7841C17.5489 14.9131 16.352 16.025 15.733 16.601C15.54 16.7809 15.403 16.9079 15.375 16.9369C15.3134 16.9999 15.2507 17.0619 15.187 17.1229C14.8071 17.4889 14.5231 17.7629 15.202 18.2109C15.529 18.4268 15.791 18.6038 16.052 18.7818C16.336 18.9758 16.6199 19.1688 16.9879 19.4108C17.0809 19.4708 17.1709 19.5358 17.2579 19.5978C17.5889 19.8337 17.8879 20.0457 18.2548 20.0117C18.4688 19.9917 18.6898 19.7918 18.8018 19.1918C19.0668 17.7749 19.5878 14.7061 19.7078 13.4411C19.7151 13.336 19.7107 13.2304 19.6948 13.1262C19.6853 13.0421 19.6447 12.9646 19.5808 12.9092C19.4898 12.8464 19.3813 12.8138 19.2708 12.8162C18.9708 12.8212 18.5078 12.9822 16.287 13.9061Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramHover);
export default __webpack_public_path__ + "static/media/telegram_hover.d772138612bf48231322ae925b2b7a50.svg";
export { ForwardRef as ReactComponent };